import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import s from './giftBox.module.css';

const mapStateToProps = ({ language, page: { giftEmail } }) => ({
  email: giftEmail,
  language,
});

const Component = ({ language, email, onChange }) => (
  <React.Fragment>
    <h4 className={`${s.gift_box_title} summary_key`}>
      {language['returns.step_3.gift_box_title']}
    </h4>
    <div className={s.gift_box_holder}>
      <div
        className={s.gift_box_msg}
        dangerouslySetInnerHTML={{ __html: language['returns.step_3.gift_box_msg'] }}
      />
      <form name="giftReturnsForm">
        <input
          className={`${s.gift_returns_input} gift-returns-input`}
          type="email"
          name="giftReturnsInput"
          placeholder={language['returns.step_3.gift_box_placeholder']}
          value={email}
          required
          onChange={(e) => onChange(e.target.value)}
        />
      </form>
    </div>
  </React.Fragment>
);

Component.propTypes = {
  language: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  onChange: PropTypes.string.isRequired,
};

export const GiftBox = connect(mapStateToProps)(Component);
